import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getIsStartingImageSelectorOpen } from '../../redux/form/selectors';
import { loadPersistentFormValues } from '../../redux/form/actions';
import PromptInputDesktop from './PromptInput/dsPresets/PromptInputDesktop';
import PromptInputMobile from './PromptInput/dsPresets/PromptInputMobile';
import StartingImageSelector from './StartingImageSelector';
import { usePromptFormAction } from './usePromptFormAction';
import s from './PromptForm.scss';
const PromptForm = ()=>{
    const dispatchLoadPersistentFormValues = useAction(loadPersistentFormValues);
    const isMobile = useContext(MobileContext);
    const isStartingImageSelectorOpen = useSelector(getIsStartingImageSelectorOpen);
    const [handleSubmit, formAction] = usePromptFormAction();
    useEffect(()=>{
        dispatchLoadPersistentFormValues();
    }, [
        dispatchLoadPersistentFormValues
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit
    }, isMobile ? /*#__PURE__*/ React.createElement(PromptInputMobile, {
        formAction: formAction
    }) : /*#__PURE__*/ React.createElement(PromptInputDesktop, {
        formAction: formAction
    }))), /*#__PURE__*/ React.createElement(StartingImageSelector, {
        isOpen: isStartingImageSelectorOpen
    }));
};
PromptForm.displayName = 'PromptForm';
export default PromptForm;

//# sourceMappingURL=PromptForm.js.map